import ShiftChartContainer from './ShiftChartContainer';

export default ShiftChartContainer;
